import { RouteObject } from 'react-router';

import { ROUTES } from '~shared/routes';

export const ordersRoutes: RouteObject = {
  path: ROUTES.orders.root,
  children: [
    {
      index: true,
      lazy: async () => {
        const { BasketsPage } =
          await import('../../../pages/orders/Baskets.page');

        return { Component: BasketsPage };
      },
    },
    {
      path: ROUTES.orders.detail,
      lazy: async () => {
        const { BasketPage } =
          await import('../../../pages/orders/Basket.page');

        return { Component: BasketPage };
      },
    },
  ],
};
